import type { Artist } from '@engage/api-v2/generated/../../api-v2-models/generated/Artist';
import { useContext, useMemo } from 'react';
import { SearchPageContext } from './types';

/**
 * If viewing artist, waits until the artist search completes to return the artist.
 * @returns Artist or undefined
 */
export const useArtist = (): Artist | undefined => {
  const {
    pageState: { status, artistId, artists },
  } = useContext(SearchPageContext);

  return useMemo(() => {
    if (status !== 'viewingArtist') {
      return undefined;
    }

    if ((artists?.length ?? 0) > 0) {
      return artists?.find(artist => artist.artist?.id === artistId)?.artist;
    }
    return undefined;
  }, [status, artistId, artists]);
};
